import TextStyle from "@tiptap/extension-text-style"

export const FontStylesExtension = TextStyle.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            fontSize: {
                default: "16px",
                parseHTML: (element) => element.style.fontSize,
                renderHTML: (attributes) =>
                    attributes?.fontSize
                        ? {
                              style: `font-size: ${attributes.fontSize}`,
                          }
                        : {},
            },

            lineHeight: {
                default: "100%",
                parseHTML: (element) => element.style.lineHeight,
                renderHTML: (attributes) =>
                    attributes?.lineHeight
                        ? {
                              style: `line-height: ${attributes.lineHeight}`,
                          }
                        : {},
            },
        }
    },

    addCommands() {
        return {
            ...this.parent?.(),
            setFontSize:
                (fontSize) =>
                ({ commands }) => {
                    return commands.setMark(this.name, { fontSize })
                },
            unsetFontSize:
                () =>
                ({ chain }) => {
                    return chain().setMark(this.name, { fontSize: "16px" }).removeEmptyTextStyle().run()
                },

            setLineHeight:
                (lineHeight) =>
                ({ commands }) => {
                    return commands.setMark(this.name, { lineHeight })
                },
            unsetLineHeight:
                () =>
                ({ chain }) => {
                    return chain().setMark(this.name, { lineHeight: "100%" }).removeEmptyTextStyle().run()
                },
        }
    },
})
